export default "__VITE_ASSET__DNktRBz8__"